exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#wacg-wrapper .v-snack__content{position:relative;overflow:visible!important}#wacg-wrapper .v-snack__content .snack-close{background:#eee;position:absolute;top:0;transform:translate(50%,-50%);right:0;padding:5px;height:20px;display:flex;align-items:center;width:20px;border-radius:100%;cursor:pointer}#wacg-wrapper .v-snack__content .snack-close svg{height:10px;width:10px;fill:#aaa}", ""]);

// exports
